import React from 'react';
import AppImage from '@/components/ui/AppImage';

interface HeroSectionProps {
  className?: string;
}

const HeroSection = ({ className = '' }: HeroSectionProps) => {
  return (
    <section className={`relative w-full h-[500px] lg:h-[600px] overflow-hidden ${className}`}>
      <div className="absolute inset-0">
        <AppImage
          src="/assets/images/WhatsApp_Image_2026-02-07_at_15.45.16-1770533980186.jpeg"
          alt="Black and white photo of athlete in starting position on track demonstrating explosive power and focus"
          className="w-full h-full object-cover object-center"
          priority />

        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-transparent" />
      </div>
      
      <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
        <div className="max-w-2xl">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold text-white mb-6 leading-tight">
            From Record Holder to<br />
            <span className="text-theme-orange">Legacy Builder</span>
          </h1>
          <p className="text-lg sm:text-xl text-white/90 font-body leading-relaxed">
            The story of how a national champion chose mentorship over fame, creating a movement that transforms lives through disciplined training and earned confidence.
          </p>
        </div>
      </div>
    </section>);

};

export default HeroSection;